var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { position: "relative" } }, [
    _vm.issetDefault || _vm.isOpensaas || _vm.isNoopen || _vm.isokopensaas
      ? _c("div", { staticClass: "zhezhao" })
      : _vm._e(),
    _vm._v(" "),
    _vm.issetDefault
      ? _c("div", { staticClass: "tanchuang szmoren" }, [
          _c("div", { staticClass: "over" }, [
            _c("img", {
              staticClass: "right xs",
              attrs: { src: "/static/img/qiye/chahao.png", alt: "" },
              on: { click: _vm.guanbitc }
            })
          ]),
          _vm._v(" "),
          _vm.isDefault
            ? _c("div", [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "tc-anniu" }, [
                  _c("button", { on: { click: _vm.setDefault } }, [
                    _vm._v("确认")
                  ]),
                  _vm._v(" "),
                  _c("button", { on: { click: _vm.guanbitc } }, [
                    _vm._v("取消")
                  ])
                ])
              ])
            : _c("div", [_vm._m(1), _vm._v(" "), _vm._m(2)])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isOpensaas
      ? _c("div", { staticClass: "tanchuang ktsass" }, [
          _c("div", { staticClass: "over" }, [
            _c("img", {
              staticClass: "right xs",
              attrs: { src: "/static/img/qiye/chahao.png", alt: "" },
              on: { click: _vm.guanbitc }
            })
          ]),
          _vm._v(" "),
          _vm.ktsass
            ? _c("div", [
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "tc-anniu" }, [
                  _c("button", { on: { click: _vm.confirmSaas } }, [
                    _vm._v("确认")
                  ]),
                  _vm._v(" "),
                  _c("button", { on: { click: _vm.guanbitc } }, [
                    _vm._v("取消")
                  ])
                ])
              ])
            : _c("div", [
                _vm._m(4),
                _vm._v(" "),
                _c("div", { staticStyle: { "margin-top": "40px" } }, [
                  _c(
                    "span",
                    {
                      staticClass: "gs-btn1 dianji",
                      on: { click: _vm.showServeWin }
                    },
                    [_vm._v("进入服务")]
                  )
                ])
              ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isokopensaas
      ? _c(
          "div",
          {
            staticClass: "tanchuang qy-yikaitong",
            staticStyle: { width: "493px", height: "264px" }
          },
          [
            _c("div", { staticClass: "over" }, [
              _c("img", {
                staticClass: "right xs",
                attrs: { src: "/static/img/qiye/chahao.png", alt: "" },
                on: { click: _vm.guanbitc }
              })
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._m(5),
              _vm._v(" "),
              _c("div", { staticClass: "tc-context" }, [
                _c("p", [
                  _vm._v(
                    "进入服务方式一：可通过添加企业中加入企业申请，待管理员批准通过"
                  )
                ]),
                _vm._v(" "),
                _c("p", [_vm._v("进入服务方式二：联系管理员邀请加入")]),
                _vm._v(" "),
                _c("p", [
                  _c("span", [_vm._v("saas服务管理员：")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.admin))])
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("span", [_vm._v("saas服务管理员手机号：")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.adminMobile))])
                ]),
                _vm._v(" "),
                _vm._m(6)
              ])
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isNoopen
      ? _c("div", { staticClass: "tanchuang nokaitong" }, [
          _c("div", { staticClass: "over" }, [
            _c("img", {
              staticClass: "right xs",
              attrs: { src: "/static/img/qiye/chahao.png", alt: "" },
              on: { click: _vm.guanbitc }
            })
          ]),
          _vm._v(" "),
          _vm._m(7)
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          position: "absolute",
          top: "-68px",
          right: "-23%"
        }
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.searchValue,
              expression: "searchValue"
            }
          ],
          staticClass: "seach-input",
          attrs: { placeholder: "请输入公司名称", type: "text" },
          domProps: { value: _vm.searchValue },
          on: {
            keyup: function($event) {
              if (
                !("button" in $event) &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.searchCompany($event)
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.searchValue = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c("el-button", {
          attrs: { icon: "el-icon-search" },
          on: { click: _vm.searchCompany }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "qiyebox",
        staticClass: "gs-qiyebox over",
        class: _vm.isheigh ? "heigh" : "",
        staticStyle: { "padding-bottom": "50px" }
      },
      _vm._l(_vm.arr, function(d, i) {
        return _c("div", { key: i, staticClass: "gs-xiangqing gs-list" }, [
          _c(
            "div",
            { staticClass: "gs-shang" },
            [
              d.saas_
                ? _c(
                    "el-dropdown",
                    {
                      attrs: {
                        trigger: "hover",
                        size: "mini",
                        placement: "bottom-start"
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "shezhi xs",
                        attrs: { src: "/static/img/shezhi.png", alt: "设置" }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          d.default_
                            ? _c("el-dropdown-item", [
                                _c(
                                  "span",
                                  {
                                    on: {
                                      click: function($event) {
                                        _vm.hideDefaultWin(i)
                                      }
                                    }
                                  },
                                  [_vm._v("取消默认")]
                                )
                              ])
                            : _c("el-dropdown-item", [
                                _c(
                                  "span",
                                  {
                                    on: {
                                      click: function($event) {
                                        _vm.showDefaultWin(i)
                                      }
                                    }
                                  },
                                  [_vm._v("设为默认")]
                                )
                              ]),
                          _vm._v(" "),
                          _c("el-dropdown-item", [
                            _c(
                              "span",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.closeServer(i)
                                  }
                                }
                              },
                              [_vm._v("关闭服务")]
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              d.default_
                ? _c("img", {
                    staticClass: "gs-morenimg",
                    attrs: { src: "/static/img/moren2xL.png", alt: "" }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "gs-xqleft" }, [
            _c("p", { staticClass: "gs-qynema" }, [
              _c(
                "span",
                {
                  staticClass: "xs",
                  on: {
                    click: function($event) {
                      _vm.getEnterpriseInfo(d)
                    }
                  }
                },
                [_vm._v(_vm._s(d.name))]
              )
            ]),
            _vm._v(" "),
            _c("p", { staticStyle: { margin: "16px 0px" } }, [
              _vm._v("\n          服务类型：\n          "),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(
                    d.appId == "make-app"
                      ? "制造云"
                      : d.appId == "trade-app"
                      ? "贸易云"
                      : "金融云"
                  )
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "gs-xqright over" }, [
            d.saas_
              ? _c(
                  "div",
                  {
                    staticClass: "gs-xqright-left left",
                    staticStyle: { width: "67%" }
                  },
                  [
                    _c("p", [
                      _c("span", [_vm._v("管理员：")]),
                      _vm._v(
                        "\n            " + _vm._s(d.admin) + "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _c("span", [_vm._v("联系方式：")]),
                      _vm._v(
                        "\n            " +
                          _vm._s(d.adminMobile) +
                          "\n          "
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "gs-border gs-xqright-right right" }, [
              d.saas_
                ? _c(
                    "span",
                    {
                      staticClass: "gs-btn1 xs green",
                      on: {
                        click: function($event) {
                          _vm.selectServe(d)
                        }
                      }
                    },
                    [_vm._v("进入使用")]
                  )
                : _c(
                    "span",
                    {
                      staticClass: "gs-btn1 kaitong xs blue",
                      on: {
                        click: function($event) {
                          _vm.showOpenServeWin(d, i)
                        }
                      }
                    },
                    [_vm._v("立即开通")]
                  )
            ])
          ])
        ])
      })
    ),
    _vm._v(" "),
    !_vm.searchStatus
      ? _c(
          "div",
          { staticStyle: { "text-align": "center" } },
          [
            _c("el-pagination", {
              attrs: {
                background: "",
                "page-size": _vm.size,
                layout: "prev, pager, next",
                total: _vm.list.length
              },
              on: { "current-change": _vm.handleCurrentChange }
            })
          ],
          1
        )
      : _c(
          "div",
          { staticStyle: { "text-align": "center" } },
          [
            _c("el-pagination", {
              attrs: {
                background: "",
                "page-size": _vm.searchSize,
                layout: "prev, pager, next",
                total: _vm.searchArrLength
              },
              on: { "current-change": _vm.handleCurrentChange }
            })
          ],
          1
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tc-text tc-queren" }, [
      _c("span", [_vm._v("是否确认设为默认企业？")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tc-conent" }, [
      _c("img", { attrs: { src: "/static/img/qiye/dengji@1x.png", alt: "" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tc-text" }, [
      _c("span", [_vm._v("已设为默认企业")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tc-text tc-queren" }, [
      _c("span", [_vm._v("是否确认开通saas服务？")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tc-text tc-conent" }, [
      _c("span", [_vm._v("开通成功")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tc-okkaitong" }, [
      _c("span", [_vm._v("该企业已开通服务")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", [_vm._v("saas服务管理员邮箱：")]),
      _vm._v(" "),
      _c("span")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "tc-conent" }, [
        _c("img", {
          attrs: { src: "/static/img/qiye/buneng kaitong@1x.png", alt: "" }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tc-text" }, [
        _c("p", [_vm._v("您已开通了10个企业服务")]),
        _vm._v(" "),
        _c("p", [_vm._v("不能再继续开通服务")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-235cdc14", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-235cdc14","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/conenter/company.vue
// module id = null
// module chunks = 